// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "3b5ede82f44fb51b","4276": "5549c740df38f3b1","5680": "31832f4d40994658","7064": "11944916995a3eed","8476": "82c49b83a1f98e2b","8626": "65028474d47e2978","878": "39c4f8da5787be4b","9474": "943459ce3f1be2fa","9755": "6670f9cdaf9b50cc",}[chunkId] + ".js"
}